import { ThemeEvents } from '@theme/events';

class SoConversionPanel extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    const section = this.closest('.shopify-section');
    section?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, {
      signal: this.#abortController.signal,
    });
    this.#render(this.dataset.variantPrice);
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  #onVariantUpdate = (event) => {
    if (String(event.detail.data.productId) !== String(this.dataset.productId)) return;
    this.#render(event.detail.resource?.price);
  };

  #render(priceValue) {
    const price = Number(priceValue || 0);
    const threshold = Number(this.dataset.freeShippingThreshold || 0);
    const heading = this.querySelector('[data-delivery-heading]');
    const shipping = this.querySelector('[data-shipping-message]');
    if (!heading || !shipping) return;

    const now = new Date();
    const day = now.getDay();
    const hour = now.getHours();
    const weekday = day >= 1 && day <= 5;

    if (weekday && hour < 14) {
      heading.textContent = "14:00'a kadar sipariş verirsen bugün kargoda";
    } else if (day === 5 || day === 6 || day === 0) {
      heading.textContent = 'İlk iş günü kargoda';
    } else {
      heading.textContent = 'Yarın kargoda';
    }

    if (price >= threshold) {
      shipping.textContent = this.dataset.freeShippingText || '';
      return;
    }

    const remaining = Math.max(threshold - price, 0) / 100;
    const formatted = new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', maximumFractionDigits: 0 }).format(remaining);
    shipping.textContent = (this.dataset.shippingRemainingText || '[amount]').replace('[amount]', formatted);
  }
}

if (!customElements.get('so-conversion-panel')) {
  customElements.define('so-conversion-panel', SoConversionPanel);
}
